<template>
  <div>
    <v-row dense no-gutters>
      <v-col md="12">
        <v-card>
          <v-card-title v-if="id_area == 4">
            OSPETAX
            <v-spacer></v-spacer>
            <autocompletar v-model="buscado"></autocompletar>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-title v-if="id_area == 5">
            OSPICAL
            <v-spacer></v-spacer>
            <autocompletarospical v-model="buscado"></autocompletarospical>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense no-gutters>
      <v-col md="12">
        <Administrar
          titulo="Consulta de datos"
          readonly
          :modificaInternacion="true"
          v-if="Seleccionado && Seleccionado.id_afiliado != 0"
        ></Administrar>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Administrar from '@/components/Beneficiarios/Administrar.vue'
import autocompletar from '@/components/Beneficiarios/AutoNombreDNINroAfiOspetax'
import autocompletarospical from '@/components/Beneficiarios/AutoNombreDNINroAfiOspical'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Beneficiarios',
  props: ['id_area'],
  data: function () {
    return {
      buscado: undefined
    }
  },
  components: {
    Administrar,
    autocompletar,
    autocompletarospical
  },
  computed: {
    ...mapState('beneficiarios', ['Lista', 'Seleccionado'])
  },
  methods: {
    ...mapActions('beneficiarios', ['select'])
  },
  watch: {
    buscado() {
      this.select(this.buscado)
    }
  }
}
</script>
<style></style>
